import React from 'react'
import Helmet from 'react-helmet'

import { Skeleton } from '@sketch/components'

import { WorkspaceProfilePublications } from '../WorkspaceProfilePublications'

import {
  Container,
  ProfileAvatar,
  ProfileHeader,
  ProfileInfoContainer,
  PublishedDocumentsContainer,
} from './WorkspaceProfileLayout.styles'

import { useGetPublications } from '../../hooks'
import { WorkspaceProfileFragment } from '@sketch/gql-types'
import { BrandNewProfileBanner } from '../../components/BrandNewProfileBanner'

interface WorkspaceProfileLayoutProps {
  workspaceId: string
  isProfileEditRoute: boolean
  profile: WorkspaceProfileFragment
  profileInfo: React.ReactNode
}

export const WorkspaceProfileLayout = (props: WorkspaceProfileLayoutProps) => {
  const { profile, isProfileEditRoute, profileInfo } = props
  const workspaceName = profile?.workspace.name!
  const workspaceAvatar = profile?.workspace.avatar
  const isOfficial = !!profile?.isOfficial

  const { loading } = useGetPublications(profile.workspace.identifier)

  const profileContent = loading ? (
    <>
      <Skeleton width="320px" height="48px" style={{ marginBottom: 12 }} />
      <Skeleton width="470px" height="30px" style={{ marginBottom: 8 }} />
      <Skeleton width="350px" height="30px" style={{ marginBottom: 8 }} />
      <Skeleton width="350px" height="30px" />
    </>
  ) : (
    profileInfo
  )

  return (
    <>
      {workspaceName && (
        <Helmet>
          <title>{`${workspaceName} · Sketch`}</title>
          <meta property="og:title" content={`${workspaceName} · Sketch`} />
          <meta
            property="og:description"
            content={`Resources from ${workspaceName}, made with Sketch — ready to use in your own projects.`}
          />
          <meta
            property="og:image"
            content={
              workspaceAvatar?.large ?? workspaceAvatar?.small ?? undefined
            }
          />
        </Helmet>
      )}

      <Container isProfileEditRoute={isProfileEditRoute}>
        <ProfileHeader>
          <ProfileAvatar
            workspaceName={workspaceName}
            avatar={workspaceAvatar}
            isOfficial={isOfficial}
          />
          <ProfileInfoContainer>{profileContent}</ProfileInfoContainer>
        </ProfileHeader>
        {isProfileEditRoute && <BrandNewProfileBanner />}

        <PublishedDocumentsContainer>
          <WorkspaceProfilePublications {...props} />
        </PublishedDocumentsContainer>
      </Container>
    </>
  )
}
